<template>
  <div class="box">
    <div class="organization" :class="[option_1]" @click="clickOption(1)">
      <div class="area">耆智園</div>
      <div class="area">&nbsp;&nbsp;· 沙田區</div>
      <div class="area">&nbsp;&nbsp;· 大埔區</div>
      <div class="area">&nbsp;&nbsp;· 新界北區</div>
    </div>

    <div class="organization" :class="[option_2]" @click="clickOption(2)">
      <div class="area">信義會</div>
      <div class="area">&nbsp;&nbsp;· 屯門區</div>
      <div class="area">&nbsp;&nbsp;· 元朗區</div>
      <div class="area">&nbsp;&nbsp;· 天水園區</div>
    </div>

    <div class="organization" :class="[option_3]" @click="clickOption(3)">
      <div class="area">樂善堂</div>
      <div class="area">&nbsp;&nbsp;· 九龍城區</div>
      <div class="area">&nbsp;&nbsp;· 黃大仙區</div>
      <div class="area">&nbsp;&nbsp;· 油尖旺區</div>
      <div class="area">&nbsp;&nbsp;· 深水埗區</div>
      <div class="area">&nbsp;&nbsp;· 荃灣區</div>
      <div class="area">&nbsp;&nbsp;· 葵青區</div>
    </div>

    <div class="organization" :class="[option_4]" @click="clickOption(4)">
      <div class="area">靈寶協會</div>
      <div class="area">&nbsp;&nbsp;· 西貢區</div>
      <div class="area">&nbsp;&nbsp;· 觀塘區</div>
      <div class="area">&nbsp;&nbsp;· 港島東區</div>
    </div>
  </div>

</template>

<script>
export default {
  name: "FollowUpOrganization",
  data() {
    return {
      option_1: 'unselect',
      option_2: 'unselect',
      option_3: 'unselect',
      option_4: 'unselect',
    }
  },
  methods: {
    clickOption: function (option) {
      this.option_1 = this.option_2 = this.option_3 = this.option_4 = 'unselect';
      switch (option) {
        case 1: this.option_1 = 'selected'; break;
        case 2: this.option_2 = 'selected'; break;
        case 3: this.option_3 = 'selected'; break;
        case 4: this.option_4 = 'selected'; break;
      }

      this.$emit('selectOrganization', option)
    }
  }
}
</script>

<style scoped>
.box{
  margin: 0 auto;
  width: 86%;
  margin-top: 1vh;
  transform: translate(9%, 0);
}
.organization{
  float: left;
  width: 18%;
  border-radius: 8px;
  min-height: clamp(12rem, 26vw, 18rem);
  font-size: var(--ecs-font-md);
  margin-right: 3vw;
  padding: 0.75rem clamp(0.5rem, 1.6vw, 1rem);
  line-height: 1.25;
  overflow-wrap: anywhere;
  cursor: default;
}
  .unselect{
    color: #666666;
    border: #666666 3px solid;
  }
  .selected{
    color: #94c43b;
    border: #94c43b 3px solid;
  }
  .area{
    font-size: var(--ecs-font-sm);
  }
</style>
